import cookie from "js-cookie";
import { getClient } from "lib/apolloClient";
import { VIEWER_COUNTRY } from "data/general/gql";

type HrefLangType = {
  hreflang: string;
  href: string;
};

export const getHrefLangTags = (): HrefLangType[] => {
  return (
    [...document.querySelectorAll('link[rel="alternate"]')] as HTMLLinkElement[]
  ).map((link) => {
    return { hreflang: link.hreflang, href: link.href };
  });
};

export const getRedirectHref = (
  hreflang: string,
  hreflangTags: HrefLangType[]
): string | undefined => {
  return hreflangTags.find((tag) => tag.hreflang === hreflang)?.href;
};

export const removeCookieIfNeeded = async (
  viewerCountry: string,
  storePreference: string | null,
  locale?: string
): Promise<void> => {
  const isGbOnGB =
    storePreference === "GB" && viewerCountry === "GB" && locale !== "us";
  const isUsOnUs =
    storePreference === "US" && viewerCountry === "US" && locale === "us";
  if (isGbOnGB || isUsOnUs) {
    await cookie.remove("store-country-preference");
  }
};

export const getViewerCountry = async (): Promise<string | null> => {
  try {
    const { data } = await getClient().query({
      query: VIEWER_COUNTRY,
      variables: {}
    });
    return data?.viewerCountry;
  } catch {
    return null;
  }
};
